import React, { ReactNode } from 'react';
import { Layout } from 'antd';

const { Content } = Layout;

interface AppContentProps {
  children: ReactNode;
}

const AppContent: React.FC<AppContentProps> = ({ children }) => (
  <Content>
    <div
      className='AppContent'
      style={{
        padding: '12px 24px',
        minHeight: 360,
        borderRadius: 16,
        height: 'calc(100vh - 64px)', // Adjust this based on your header height
      }}
    >
      {children}
    </div>
  </Content>
);

export default AppContent;
